import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import fileIcon from "../assets/images/fileUpload-icon.svg";
import deleteIcon from "../assets/images/deleteIcon.svg";
import { toast } from "react-toastify";
import { Link, useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import previewPdfUrl from "../assets/images/pdf-icon.svg";
import { useSearchParams } from 'react-router-dom';

const SKIP_HOOK_URL = "https://hook.eu1.make.com/a9fqigx4f7te8m54qxrxc0putswgn7jt";

const FileUpload = () => {
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [error, setError] = useState("");
  const fileInputRef = useRef(null);
  const location = useLocation();
  const { email, phoneNumber, fullName, } = location.state || {};
  const navigate = useNavigate()
const [searchParams, setSearchParams] = useSearchParams();
   
  useEffect(()=>{    
    if (!email && !searchParams.get("skip")) {
      navigate('/register?step=1')
    }
  },[])
  useEffect(() => {
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      if (!isValidFileType(selectedFile)) {
        setError("סוג קובץ לא נתמך! נא להעלות קובץ PNG, JPEG או PDF.");
        return;
      }

      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
      setError("");
      setFile(selectedFile);
      setPreviewUrl(URL.createObjectURL(selectedFile));
      event.target.value = "";
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFile = event.dataTransfer.files[0];

    if (droppedFile) {
      if (!isValidFileType(droppedFile)) {
        setError("סוג קובץ לא נתמך! נא להעלות קובץ PNG, JPEG או PDF.");
        return;
      }

      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
      setError("");
      setFile(droppedFile);
      setPreviewUrl(URL.createObjectURL(droppedFile));
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleBrowseClick = () => {
    if (!file && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleRemoveFile = () => {
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
    }
    setFile(null);
    setPreviewUrl("");
    setError("");
  };

  const isValidFileType = (file) => {
    const validTypes = ["image/png", "image/jpeg", "application/pdf"];
    return validTypes.includes(file.type);
  };

  const handleProfilePicUpload = () => {
    if (!file) {
      setError("אנא העלה קובץ לפני שליחה.");
      return;
    }
  
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "profile_pics");
    axios
      .post(
        "https://api.cloudinary.com/v1_1/deceg51ej/image/upload",
        formData
      )
      .then((cloudinaryResponse) => {
        const imageUrl = cloudinaryResponse.data.secure_url;
        axios.post(`${process.env.REACT_APP_BE_BASE_URL}user/register?step=5`, {
          profile_pic: imageUrl,
          email:email
        }).then((res)=>{
          toast.success("Data is successfully saved");
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "lead_form_submit",
            form_name: "register_step_5_lead_form",
            form_id: `register_step_5_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
            page_url: window.location.href,
          });
          console.log("GTM lead_form_submit event fired for register step 5");
          navigate('/register?step=5', { state: { email, phoneNumber, fullName, idNumber: location?.state?.idNumber, birthDate: location?.state?.birthDate, issueDate: location?.state?.issueDate  }});
        }).catch((err)=>{
          toast.error("Failed to save data, please try again");
        })
      })
      .then((apiResponse) => {
        handleRemoveFile();
      })
      .catch((error) => {
        console.error("Error uploading image:", error);
        toast.error("Failed to save data, please try again");
      });
  };
  

  return (
    <div className="form_box">
      <h2 className="box_head">הגיע הזמן לעשות סדר <br /> בפנסיה ובביטוחים שלך</h2>
      <p className="login_label">זה המקום לצרף את צילום תעודת הזהות שלך</p>

      {error && <span className="error-message">{error}</span>}

      <div
        className={previewUrl === "" ? "file_upload_div" : "file_notUpload_div"}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onClick={handleBrowseClick}
        title="Upload"
      >
        {!previewUrl ? (
          <>
            <img className="file_icon" src={fileIcon} alt="upload-file" />
            <p className="file_desc">
              גרור ושחרר את תמונת השלט שלך כאן או{" "}
              <span className="file_span">
                עיין
              </span>{" "}
            </p>
            <p className="upload_type">תמיכה: png, jpeg, pdf</p>
            <input
              type="file"
              accept="image/png, image/jpeg, application/pdf"
              onChange={handleFileChange}
              style={{ display: "none" }}
              ref={fileInputRef}
            />
          </>
        ) : (
          <div className="file_preview">
								{file && file.type === "application/pdf" ? (
									<img src={previewPdfUrl} alt="PDF File" width={100} className="pdf_icon" />
								) : (
									<img src={previewUrl} alt="Uploaded File" className="preview_img" />
								)}
								<img
									onClick={handleRemoveFile}
									className="delete_icon"
									src={deleteIcon}
									alt="delete"
								/>
							</div>
        )}
      </div>
      <button className="login_btn" onClick={handleProfilePicUpload}>
        שלב הבא
      </button>
      {/* <Link to="/register?step=5&skip=true" className='quit_link'>לדלג</Link> */}
      <div className='text-center' onClick={() => {
        axios.post(SKIP_HOOK_URL, {
          skipped_step: 4,
          full_name: fullName,
          email,
          phone_number: phoneNumber,
          idNumber: location?.state?.idNumber,
          birthDate: location?.state?.birthDate,
          issueDate: location?.state?.issueDate,
        }).catch(() => {});
        navigate('/register?step=5&skip=true', { state: { email, phoneNumber, fullName, idNumber: location?.state?.idNumber, birthDate: location?.state?.birthDate, issueDate: location?.state?.issueDate }});
      }}>
        <span className='link_btn'>
        לדלג
        </span>
      </div>
    </div>
  );
};

export default FileUpload;
